export const getTerms = (old: string[], term?: string) => {
  if (!term) {
    return [];
  }
  return old.join(" ") !== term ? [term] : old;
};
